var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 11.94C15.3467 12.44 15.2133 12.9133 14.9733 13.32C14.84 13.56 14.66 13.78 14.46 13.96C14 14.3867 13.3933 14.6467 12.72 14.6667C11.7466 14.6867 10.8867 14.1867 10.4133 13.42C10.16 13.0267 10.0067 12.5533 9.99999 12.0533C9.97999 11.2133 10.3533 10.4533 10.9533 9.95333C11.4067 9.58 11.98 9.34667 12.6067 9.33334C14.08 9.30001 15.3 10.4667 15.3333 11.94Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6267 12.02L12.3 12.66L13.6933 11.3133",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11334 4.96L8 8.36666L13.8467 4.97998",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.4067V8.35999",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4067 6.11334V9.88669C14.4067 9.92002 14.4067 9.94666 14.4 9.97999C13.9333 9.57333 13.3333 9.33335 12.6667 9.33335C12.04 9.33335 11.46 9.55335 11 9.92002C10.3867 10.4067 10 11.16 10 12C10 12.5 10.14 12.9733 10.3867 13.3733C10.4467 13.48 10.52 13.58 10.6 13.6734L9.38 14.3467C8.62 14.7734 7.37999 14.7734 6.61999 14.3467L3.06 12.3733C2.25333 11.9267 1.59334 10.8067 1.59334 9.88669V6.11334C1.59334 5.19334 2.25333 4.07335 3.06 3.62668L6.61999 1.65333C7.37999 1.22667 8.62 1.22667 9.38 1.65333L12.94 3.62668C13.7467 4.07335 14.4067 5.19334 14.4067 6.11334Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTick);
export default __webpack_public_path__ + "static/media/box-tick.b3311069271d344d6055da2d57541999.svg";
export { ForwardRef as ReactComponent };